import { IApplicationState } from '../types/redux';

export function priceForObjectSelector(state: IApplicationState) {
  return state.newbuilding.priceForObjectFromDeveloperDisplay;
}
